import { render, staticRenderFns } from "./DialogTable.vue?vue&type=template&id=0ede6220"
import script from "./DialogTable.vue?vue&type=script&lang=js"
export * from "./DialogTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports